import {
  List,
  TextField,
  EditButton,
  ShowButton,
  SimpleList,
  ReferenceField,
  Datagrid,
  Button,
  FunctionField,
  BooleanField,
  TopToolbar,
  CreateButton,
} from "react-admin";
import { EmptyList } from "server/components";
import { useMediaQuery } from "@mui/material";
import permissions from "app/permissions";
import { settings } from "app";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import { useNavigate } from "react-router";
import { AdministrationServicePath, STUDY_DEPARTMENT_INFO, MOBILE_BREAKPOINT, STRUCTURAL_UNITS } from "utils/constants";
import SecuredComponent from "server/security/SecuredComponent";
import { AdministrationExporter } from "../XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { administrationRequests } from "api/administrationApi";
import { MobileListRow } from "features/MobileListRow";

const ListStructuralUnits = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  const renderActionButtons = (
    record,
    labelStudyDepartment = "Учебен отдел",
    // labelSpecifications = "Спецификации",
    labelCountries = "Вражески държави",
  ) => (
    <>
      <SecuredComponent permission={permissions.canUpdateStudyDepartmentInfo}>
        <Button
          label={labelStudyDepartment}
          color="primary"
          startIcon={<LocalLibraryIcon />}
          onClick={() => navigate(`/${AdministrationServicePath}${STUDY_DEPARTMENT_INFO}/${record.id}/edit`)}
        />
      </SecuredComponent>

      {/* hide for both university ( MU, MGU )*/}
      {/* <SecuredComponent
        permission={
          permissions.canUpdateStructuralUnitGroupSpecifications &&
          permissions.canPreviewStructuralUnitGroupSpecifications
        }
      >
        <EditGroupSpecificationDialog />
      </SecuredComponent> */}

      <SecuredComponent permission={permissions.canPreviewGroupBlacklistCountriesInfo}>
        <>
          {/* !!!!!!!!!!!!!!!!!! */}
          {/* For now this is disabled - beceause the system do NOT support AUTO STUDY GROUPS DISTRIBUTION. */}
          {/* Please do not remove this commented section! */}
          {/* <Button
            label={labelCountries}
            color="primary"
            startIcon={<PublicOffIcon />}
            onClick={() => navigate(`/${AdministrationServicePath}${COUNTRIES}/${BLACK_LIST}/${record.id}/edit`)}
          /> */}
          {/* !!!!!!!!!!!!!!!!!! */}
        </>
      </SecuredComponent>
    </>
  );

  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        {hasCreate && <CreateButton />}
        <ExportXlsButton exporter={AdministrationExporter(STRUCTURAL_UNITS)} />
      </TopToolbar>
    );
  };

  return (
    <>
      <List
        title="Структурни единици"
        sx={settings.style.expandStyle}
        actions={<ListActions hasCreate={true} />}
      >
        {isMobile ? (
          <SimpleList
            empty={<EmptyList />}
            linkType={false}
            sx={settings.style.mobileList}
            primaryText={record => (
              <MobileListRow fields={[{ label: "Име на български език", value: record.nameBg }]} />
            )}
            secondaryText={record => (
              <div>
                <MobileListRow fields={[{ label: "Име на английски език", value: record.nameEn }]} />
                <MobileListRow
                  fields={[
                    {
                      label: "Направление",
                      value: (
                        <ReferenceField
                          source="directionId"
                          reference={administrationRequests.getDirectionsSelect()}
                        >
                          <TextField
                            label="Дирекция"
                            source="name"
                          />
                        </ReferenceField>
                      ),
                    },
                  ]}
                />
                <MobileListRow
                  fields={[
                    { label: "Предлага специална група", value: record.hasSpecialGroup ? "Да" : "Не" },
                  ]}
                />
                <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                  {renderActionButtons(record, "", "", "")}
                </div>
              </div>
            )}
            tertiaryText={() => (
              <>
                <SecuredComponent permission={permissions.canUpdateStructuralUnits}>
                  <EditButton label="" />
                </SecuredComponent>

                <ShowButton label="" />
              </>
            )}
          />
        ) : (
          <Datagrid
            bulkActionButtons={false}
            rowClick={false}
          >
            <TextField
              source="nameBg"
              label="Име на български език"
              sortable={false}
            />
            <TextField
              source="nameEn"
              label="Име на английски език"
              sortable={false}
            />
            <ReferenceField
              label="Направление"
              source="directionId"
              reference={administrationRequests.getDirectionsSelect()}
            >
              <TextField
                label="Дирекция"
                source="name"
              />
            </ReferenceField>
            <BooleanField
              source="hasSpecialGroup"
              label="Предлага специална група"
              sortable={false}
            />
            <SecuredComponent permission={permissions.canUpdateStructuralUnits}>
              <EditButton />
            </SecuredComponent>
            <FunctionField render={record => renderActionButtons(record)} />
            <ShowButton />
          </Datagrid>
        )}
      </List>
    </>
  );
};
export default ListStructuralUnits;
